import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { Paper, ListItem, ListItemText } from "@mui/material";

type DraggableWordProps = {
  word: {
    id: string;
    text: string;
  };
};

const DraggableWord: React.FC<DraggableWordProps> = ({ word }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: "draggable" + word.id,
  });

  const style = {
    transform: `translate3d(${transform?.x ?? 0}px, ${transform?.y ?? 0}px, 0)`,
    padding: "8px",
    margin: "8px",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    cursor: "grab",
    display: "inline-block",
    width: "auto",
  };

  return (
    <Paper ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <ListItem>
        <ListItemText primary={word.text} />
      </ListItem>
    </Paper>
  );
};

export default DraggableWord;
